/**
 * Server-side structured data for the DpaSellOrRefinance tool page.
 * Lives in a data module (not the page component) so routeMeta can emit it
 * into the server HTML; react-helmet would only add it after hydration.
 */
import { DPA_FAQS } from "@/data/dpaSellRefinanceData";

  export const DPA_SELL_OR_REFINANCE_JSON_LD: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      name: "What Happens to Your Down Payment Assistance if You Sell or Refinance Early?",
      url: "https://www.homeapproach.com/tools/dpa-sell-or-refinance",
      description:
        "How down payment assistance behaves when you sell early or refinance: payoff timing, unforgiven balances, subordination, and recapture tax.",
      isPartOf: {
        "@type": "WebSite",
        name: "Home Approach",
        url: "https://www.homeapproach.com",
      },
      publisher: {
        "@type": "Organization",
        name: "Home Approach",
        url: "https://www.homeapproach.com",
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
        { "@type": "ListItem", position: 2, name: "Tools", item: "https://www.homeapproach.com/tools" },
        {
          "@type": "ListItem",
          position: 3,
          name: "DPA if You Sell or Refinance",
          item: "https://www.homeapproach.com/tools/dpa-sell-or-refinance",
        },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: DPA_FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};
